/**
 * KeyDS's modal cancels the default action of every click inside it.
 *
 * `ResponsiveModalWrapper` puts an `onClick` on the modal Body that calls both
 * `preventDefault()` and `stopPropagation()`, to keep a click in the body from
 * bubbling out to the Overlay's handler and closing the modal. The
 * stopPropagation is what that comment is about; the preventDefault comes along
 * with it and applies to every click in the subtree.
 *
 * That is harmless for a Button, whose behavior is its handler. It is fatal for
 * the two controls whose behavior *is* the default action:
 *
 *   - `<input type="file">` — a click whose default is prevented does not open
 *     the file picker, and reports nothing. The symptom is UPLOAD CSV FILE
 *     doing visibly nothing, with no console error.
 *   - `<a download href>` — a click whose default is prevented does not
 *     download.
 *
 * Attaching this to those elements stops their click before it reaches the
 * Body's handler, so the default action survives. React 16 dispatches all
 * handlers from its root listener, so stopping propagation on the element's own
 * synthetic click is enough to skip the ancestor's.
 *
 * Note this is invisible to jsdom: it implements neither the file picker nor
 * navigation, so a test can only catch it by asserting on `defaultPrevented`,
 * which is what index.test.jsx does.
 */
const allowDefaultActionInModal = (event) => event.stopPropagation();

export default allowDefaultActionInModal;
